import { render, staticRenderFns } from "./DefaultSidebarMenuComponent.vue?vue&type=template&id=55a6a1d7&scoped=true"
import script from "./DefaultSidebarMenuComponent.vue?vue&type=script&lang=js"
export * from "./DefaultSidebarMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a6a1d7",
  null
  
)

export default component.exports